import { get } from "lodash";
import {
  ChatBox,
  fetchInitialConfig,
  hideChatPanel,
  resetChatState,
  resetModalState,
  showChatPanel,
  showChatPrompt as showChatPromptAction,
} from "@dpdgroupuk/cc-chat-fe";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import styles from "./Chat.module.scss";
import { connect } from "react-redux";
import { compose } from "recompose";
import ChatBar from "./ChatBar";
import { chatApisClient } from "../../apis/chat";

const Chat = ({ parcel, config, dispatch }) => {
  const [retryInitialConfig, setRetryInitialConfig] = useState(0);
  const [mountChatBox, setMountChatBox] = useState(true);

  const parcelCode = get(parcel, "parcelCode", null);
  const parcelNumber = get(parcel, "parcelNumber", null);
  const postcode = get(parcel, "deliveryDetails.address.postcode", null);

  // Map to expected argument names for fetchInitialConfig
  const orderId = null;
  const postCode = postcode;
  const collectionReference = null;
  const collectionPostcode = null;

  useEffect(() => {
    if (!parcelCode && !parcelNumber && !postCode) return;
    dispatch(
      fetchInitialConfig(
        chatApisClient,
        parcelCode,
        parcelNumber,
        orderId,
        postCode,
        collectionReference,
        collectionPostcode,
        retryInitialConfig > 0
      )
    );
  }, [parcelCode, parcelNumber, postCode, retryInitialConfig, dispatch]);

  const onClose = finalClose => {
    if (finalClose) {
      dispatch(resetChatState());
      dispatch(resetModalState());

      setMountChatBox(false);
      setRetryInitialConfig(prev => prev + 1);
    }
  };

  const onChatBarClick = () => {
    setMountChatBox(true);
    dispatch(showChatPanel());
  };

  const onMinimizeClick = () => {
    dispatch(hideChatPanel());
  };

  const {
    showChatBar,
    showChatPanel: showChatBox,
    businessUnit,
  } = config || {};

  return (
    <div className={styles.chatContainer}>
      <ChatBar
        show={showChatBar}
        onClick={onChatBarClick}
        businessUnit={businessUnit}
      />
      {mountChatBox && (
        <ChatBox
          show={showChatBox}
          caseId={null}
          ratingEnabled
          parcelCode={parcelCode}
          parcelNumber={parcelNumber}
          postCode={postcode}
          onMinimize={onMinimizeClick}
          onClose={onClose}
        />
      )}
    </div>
  );
};

Chat.propTypes = {
  parcel: PropTypes.object,
};

const mapStateToProps = state => ({
  config: state.chat.config,
});

const mapDispatchToProps = dispatch => {
  return {
    showChatPanel: () => dispatch(showChatPanel()),
    hideChatPanel: () => dispatch(hideChatPanel()),
    showChatPrompt: () => dispatch(showChatPromptAction()),
    dispatch,
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Chat);
